{
  "title": "Gentle Repose",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level necromancy (ritual)",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a pinch of salt and one copper piece placed on each of the corpse’s eyes, which must remain there for the duration)",
  "duration": "10 days",
  "description": [
    "You touch a corpse or other remains. For the duration, the target is protected from decay and can’t become undead.",
    "The spell also effectively extends the time limit on raising the target from the dead, since days spent under the influence of this spell don’t count against the time limit of spells such as raise dead."
  ],
  "spellLists": ["cleric", "paladin", "wizard"]
}
